module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-maw-c6d80988359de76c15b10e7f2b6ff144.svg";